module.exports = __webpack_public_path__ + "img/visa-electron.a0c467a5.svg";